import React, { useRef, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import { Grid } from '@material-ui/core'
import GavelIcon from '@material-ui/icons/Gavel'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import glukyService from 'src/services/glukyService'
import { swalMessages } from 'src/constants'
import swal from 'sweetalert'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import {ModalRejections }from './ModalRejections'

function defaultFormValue() {
  return {
    linea: '',
    puntos: '',
    chasis: '',
    document: '',
  }
}

const RejectionReazon = () => {
  const [state, setState] = useState(defaultFormValue())
  const [showModal, setShowModal] = useState(false)
  const [info, setInfo] = useState(null)
  const rasonRefs = useRef(null)

  const onChange = (event, type) => {
    setState({ ...state, [type]: event })
  }

  const handleSearchRasons = async (event) => {
    event.preventDefault()
    const response = await glukyService.rejectionReazon(
      state.chasis,
      state.document,
    )
    if (response.razon.split('.').length > 1) {
      setInfo(response)
      setShowModal(true)
    } else {
      swal(swalMessages.NOT_FOUND)
    }
  }

  const handleSearchRasonsPlaca = async (event) => {
    event.preventDefault()
    const response = await glukyService.rejectReazonByPlaca(
      state.placa,
      state.document,
    )
    if (response.razon.split('.').length > 1) {
      setInfo(response)
      setShowModal(true)
    } else {
      swal(swalMessages.NOT_FOUND)
    }
  }
  return (
    <>
      <Card>
        <ModalRejections info={info} show={showModal} onClose={() => setShowModal(false)} />
        <CardTitle title="Busqueda por chasis y cédula" />
        <CardBody>
          <form
            ref={rasonRefs}
            autoComplete="off"
            onSubmit={handleSearchRasons}
          >
            <section>
              <h5>Buscar motivo de rechazo</h5>
            </section>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <TextField
                  label="Documento de identidad"
                  margin="normal"
                  type="number"
                  fullWidth
                  required
                  onChange={(event) => onChange(event.target.value, 'document')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  fullWidth
                  required
                  margin="normal"
                  label="# de chasis"
                  onChange={(event) => onChange(event.target.value, 'chasis')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <GavelIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <Button
                  style={{ width: '100%' }}
                  type="onSubmit"
                  color="warning"
                >
                  Buscar motivo
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardBody>
      </Card>
      <Card>
        <CardTitle title="Busqueda por placa y cédula" />
        <CardBody>
          <form
            ref={rasonRefs}
            autoComplete="off"
            onSubmit={handleSearchRasonsPlaca}
          >
            <section>
              <h5>Buscar motivo de rechazo</h5>
            </section>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <TextField
                  label="Documento de identidad"
                  margin="normal"
                  type="number"
                  fullWidth
                  required
                  onChange={(event) => onChange(event.target.value, 'document')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  fullWidth
                  required
                  margin="normal"
                  label="# de placa"
                  onChange={(event) => onChange(event.target.value, 'placa')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <GavelIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2}>
                <Button
                  style={{ width: '100%' }}
                  type="onSubmit"
                  color="warning"
                >
                  Buscar motivo
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardBody>
      </Card>
    </>
  )
}

export default RejectionReazon
